import React, { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/all';
import useWindowDimensions from '../components/useWindowDimensions';
import gsap from 'gsap';
gsap.registerPlugin(ScrollTrigger);
const QualitySection = ({ timeline }) => {
	const { width } = useWindowDimensions();
	let container = useRef();

	useGSAP(() => {
		gsap.to('.quality-heading-clone', {
			width: '100%',
		});
		timeline && width > 900
			? timeline
					.to('.quality-heading-clone', {
						width: '100%',
					})
					.fromTo(
						'.quality-header-para',
						{
							opacity: 0,
						},
						{ opacity: 1 },
						'a1'
					)
					.from(
						'.quality-header-para',
						{
							y: '100px',
							stagger: 0.3,
						},
						'a1'
					)
					.from('.card', {
						scale: 0,
						stagger: 0.1,
						ease: 'power1.inOut',
					})
			: timeline
					.to('.quality-heading-clone', {
						width: '100%',
					})
					.fromTo(
						'.card',
						{
							scale: 0,
						},
						{ scale: 1, stagger: 0.1, delay: -1, ease: 'power1.inOut' }
					);
		ScrollTrigger.refresh();
	}, [timeline, container]);

	return (
		<div
			className='quaility-section flex-container'
			ref={(el) => (container = el)}
		>
			<div className='quality-header flex-container'>
				<div className='heading-wrapper'>
					<div className='heading-container'>
						<h1 className='heading small-heading'>Why Choose Krad Global</h1>
						<h1 className='heading heading-clone quality-heading-clone small-heading'>
							Why Choose Krad Global
						</h1>
					</div>
				</div>
				{width > 650 ? (
					<div className='heading-wrapper'>
						<div className='heading-container'>
							<h1 className='heading small-heading'>
								Your Trusted Partner in Industrial Solutions
							</h1>
							<h1 className='heading heading-clone quality-heading-clone small-heading'>
								Your Trusted Partner in Industrial Solutions
							</h1>
						</div>
					</div>
				) : (
					<>
						<div className='heading-wrapper'>
							<div className='heading-container'>
								<h1 className='heading small-heading'>
									Your Trusted Partner in
								</h1>
								<h1 className='heading heading-clone quality-heading-clone small-heading'>
									Your Trusted Partner in
								</h1>
							</div>
						</div>
						<div className='heading-wrapper'>
							<div className='heading-container'>
								<h1 className='heading small-heading'>Industrial Solutions</h1>
								<h1 className='heading heading-clone quality-heading-clone small-heading'>
									Industrial Solutions
								</h1>
							</div>
						</div>
					</>
				)}

				<p className='quality-header-para'>
					Choosing the right supplier is crucial for the success of any
					projects, and at Krad Global, we are committed to exceeding your
					expectations. Here’s why we stand out.
				</p>
			</div>
			<div className='container'>
				<div className='gradient-cards'>
					<div className='card'>
						<div className='container-card bg-green-box'>
							<div className='card-svg flex-container'>
								<svg
									fill='#000000'
									height='50px'
									width='50px'
									version='1.1'
									id='Layer_1'
									xmlns='http://www.w3.org/2000/svg'
									xmlnsXlink='http://www.w3.org/1999/xlink'
									viewBox='0 0 491.52 491.52'
									xmlSpace='preserve'
								>
									<g>
										<g>
											<polygon
												points='341.834,75.025 254.212,75.025 254.212,153.526 371.893,153.526 		'
												fill='#54E8A9'
											/>
										</g>
									</g>
									<g>
										<g>
											<path
												d='M173.444,170.453c-3.504,9.829-12.81,16.925-23.829,16.925c-5.656,0-10.904,2.793-14.049,7.471
			c-1.876,2.801-2.876,6.074-2.876,9.454c0,0.065-0.018,0.125-0.019,0.19l104.616,273.099V170.453H173.444z'
												fill='#54E8A9'
											></path>
										</g>
									</g>
									<g>
										<g>
											<path
												d='M122.285,224.69c-4.21,3.104-9.361,5-14.982,5c-14,0-25.389-11.387-25.389-25.387c0-4.52-1.743-8.752-4.913-11.917
			c-3.231-3.232-7.496-5.008-12.012-5.008c-11.018,0-20.324-7.096-23.828-16.925H0.007l214.875,295.967L122.285,224.69z'
												fill='#54E8A9'
											></path>
										</g>
									</g>
									<g>
										<g>
											<path
												d='M56.952,74.992L0,153.526h41.161c3.504-9.83,12.81-16.925,23.828-16.925c9.334,0,16.925-7.596,16.925-16.926
			c0-13.999,11.389-25.387,25.389-25.387c5.613,0,10.758,1.89,14.966,4.987l9.291-24.284H56.952z'
												fill='#54E8A9'
											></path>
										</g>
									</g>
									<g>
										<g>
											<path
												d='M149.683,74.992l-17.015,44.473c0.001,0.072,0.022,0.14,0.022,0.212c0,3.282,1.054,6.735,2.893,9.479
			c0.549,0.827,1.219,1.628,2.008,2.414c3.293,3.297,7.446,5.033,12.024,5.033c11.018,0,20.324,7.096,23.829,16.925h63.843V74.992
			H149.683z'
												fill='#54E8A9'
											></path>
										</g>
									</g>
									<g>
										<g>
											<path
												d='M463.478,114.874c-2.694,11.125-12.669,19.439-24.61,19.439c-14,0-25.388-11.389-25.388-25.388
			c0-4.611-1.703-8.727-4.917-11.909c-3.339-3.381-7.48-5.1-12.099-5.1c-11.019,0-20.324-7.096-23.828-16.925h-12.69l30.099,78.536
			H491.52L463.478,114.874z'
												fill='#54E8A9'
											></path>
										</g>
									</g>
									<g>
										<g>
											<polygon
												points='390.02,170.453 345.783,285.904 276.633,466.386 491.468,170.453 		'
												fill='#54E8A9'
											/>
										</g>
									</g>
									<g>
										<g>
											<polygon
												points='254.212,170.453 254.212,477.594 371.892,170.453 		'
												fill='#54E8A9'
											/>
										</g>
									</g>
									<g>
										<g>
											<path
												d='M122.183,147.002c-2.242-2.242-4.382-4.79-6.217-7.543c-5.403-8.053-8.665-17.94-8.665-28.44
			c0,28.134-22.833,50.968-50.968,50.968c14.068,0,26.809,5.709,36.085,14.984c9.174,9.174,14.882,21.916,14.882,35.983
			c0-10.499,3.262-20.387,8.665-28.44c9.174-13.66,24.769-22.528,42.302-22.528C144.201,161.985,131.459,156.276,122.183,147.002z'
												fill='#54E8A9'
											></path>
										</g>
									</g>
									<g>
										<g>
											<path
												d='M454.232,51.055c-9.466-9.466-15.356-22.615-15.356-37.13c0,29.032-23.562,52.593-52.698,52.593
			c14.621,0,27.769,5.89,37.235,15.461c9.572,9.469,15.463,22.721,15.463,37.236c0-13.253,4.943-25.453,13.043-34.712
			c9.677-11.042,23.771-17.985,39.549-17.985C476.952,66.518,463.804,60.627,454.232,51.055z'
												fill='#54E8A9'
											></path>
										</g>
									</g>
								</svg>
							</div>
							<p className='card-title'>Commitment to Quality</p>
							<p className='card-description'>
								We prioritize quality in every aspect of our business. Working
								closely with our approved manufacturers, we ensure that our
								Products meet the highest industry standards. Our dedication to
								quality assurance is unwavering.
							</p>
						</div>
					</div>

					<div className='card'>
						<div className='container-card bg-white-box'>
							<div className='card-svg flex-container'>
								<svg
									fill='#000000'
									height='50px'
									width='50px'
									version='1.1'
									id='Layer_1'
									xmlns='http://www.w3.org/2000/svg'
									xmlnsXlink='http://www.w3.org/1999/xlink'
									viewBox='0 0 512 512'
									xmlSpace='preserve'
								>
									<g>
										<g>
											<path
												d='M226.932,399.948c-19.96,18.445-47.567,22.576-72.053,10.786c-8.852-4.263-16.322-10.149-22.17-17.199l-33.341,73.744
			c-1.517,3.355,0.177,5.884,0.975,6.815c0.798,0.93,3.039,2.989,6.585,2.003l24.272-6.756c2.766-0.769,5.562-1.14,8.319-1.14
			c11.631,0,22.578,6.583,27.849,17.492l10.962,22.685c1.601,3.315,4.604,3.646,5.854,3.621c1.226-0.016,4.242-0.414,5.758-3.769
			l53.033-117.304C237.148,392.603,231.63,395.606,226.932,399.948z'
												fill='#fe5657'
											></path>
										</g>
									</g>
									<g>
										<g>
											<path
												d='M412.631,467.279l-33.341-73.744c-5.848,7.051-13.318,12.937-22.17,17.199c-24.487,11.79-52.093,7.659-72.053-10.786
			c-4.698-4.342-10.216-7.345-16.045-9.022l53.033,117.304c1.517,3.356,4.533,3.753,5.758,3.769c1.25,0.025,4.253-0.306,5.854-3.621
			l10.962-22.685c5.27-10.909,16.218-17.492,27.849-17.492c2.757,0,5.554,0.371,8.319,1.14l24.272,6.756
			c3.546,0.987,5.788-1.072,6.585-2.003C412.454,473.162,414.148,470.633,412.631,467.279z'
												fill='#fe5657'
											></path>
										</g>
									</g>
									<g>
										<g>
											<path
												d='M438.821,207.791c-27.69-18.96-36.282-56.605-19.56-85.702c10.051-17.491,4.82-34.775-3.427-45.118
			c-8.248-10.34-23.936-19.285-43.223-13.38c-32.084,9.827-66.877-6.925-79.201-38.141C286.002,6.686,269.227,0,256,0
			c-13.227,0-30.002,6.686-37.41,25.451c-12.324,31.217-47.114,47.967-79.201,38.141c-19.289-5.904-34.974,3.039-43.223,13.38
			c-8.247,10.343-13.478,27.625-3.427,45.118c16.722,29.096,8.13,66.742-19.56,85.702c-16.646,11.399-19.431,29.24-16.489,42.136
			c2.942,12.896,13.194,27.761,33.137,30.808c33.174,5.068,57.248,35.256,54.809,68.727c-1.468,20.121,10.745,33.423,22.662,39.163
			c11.918,5.739,29.932,6.995,44.748-6.698c12.322-11.387,28.141-17.083,43.953-17.083c15.818,0,31.628,5.693,43.952,17.083
			c14.818,13.694,32.833,12.438,44.75,6.698c11.917-5.739,24.129-19.041,22.662-39.162c-2.439-33.471,21.635-63.659,54.809-68.728
			c19.943-3.047,30.193-17.913,33.137-30.808C458.252,237.03,455.465,219.189,438.821,207.791z M256,335.923
			c-72.575,0-131.619-59.044-131.619-131.619S183.424,72.684,256,72.684c72.576,0,131.619,59.044,131.619,131.619
			C387.618,276.878,328.575,335.923,256,335.923z'
												fill='#fe5657'
											></path>
										</g>
									</g>
									<g>
										<g>
											<path
												d='M255.999,97.225c-59.044,0-107.079,48.036-107.079,107.079c0,59.043,48.034,107.079,107.079,107.079
			s107.079-48.036,107.079-107.079S315.043,97.225,255.999,97.225z M310.874,193.922l-66.642,48.675
			c-2.115,1.545-4.653,2.362-7.237,2.362c-0.666,0-1.335-0.054-2.001-0.164c-3.249-0.537-6.147-2.358-8.041-5.054l-19.934-28.382
			c-3.895-5.547-2.556-13.2,2.989-17.095c5.546-3.895,13.198-2.557,17.094,2.989l12.75,18.154l56.548-41.302
			c5.473-3.995,13.15-2.803,17.146,2.671C317.543,182.248,316.346,189.924,310.874,193.922z'
												fill='#fe5657'
											></path>
										</g>
									</g>
								</svg>
							</div>
							<p className='card-title'>Proven Track Record</p>
							<p className='card-description'>
								Our successful collaborations with major oil companies and
								contractors underscore our reliability and capability. We have
								consistently delivered on complex projects, earning a reputation
								for excellence and dependability in the industry.
							</p>
						</div>
					</div>

					<div className='card'>
						<div className='container-card bg-yellow-box'>
							<div className='card-svg flex-container'>
								<svg
									width='80'
									height='80'
									viewBox='0 0 120 120'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M74.2105 36C73.373 36 72.5698 35.6839 71.9776 35.1213C71.3853 34.5587 71.0526 33.7956 71.0526 33C71.0526 32.2044 71.3853 31.4413 71.9776 30.8787C72.5698 30.3161 73.373 30 74.2105 30H86.8421C87.6796 30 88.4829 30.3161 89.0751 30.8787C89.6673 31.4413 90 32.2044 90 33V45C90 45.7956 89.6673 46.5587 89.0751 47.1213C88.4829 47.6839 87.6796 48 86.8421 48C86.0046 48 85.2014 47.6839 84.6091 47.1213C84.0169 46.5587 83.6842 45.7956 83.6842 45V40.242L65.3905 57.621C64.7983 58.1834 63.9953 58.4994 63.1579 58.4994C62.3205 58.4994 61.5175 58.1834 60.9253 57.621L52.1053 49.242L35.3905 65.121C34.7949 65.6675 33.9972 65.9699 33.1693 65.963C32.3413 65.9562 31.5492 65.6407 30.9637 65.0845C30.3782 64.5282 30.0461 63.7758 30.0389 62.9892C30.0317 62.2026 30.35 61.4448 30.9253 60.879L49.8726 42.879C50.4648 42.3166 51.2679 42.0006 52.1053 42.0006C52.9426 42.0006 53.7457 42.3166 54.3379 42.879L63.1579 51.258L79.219 36H74.2105ZM36.3158 78V87C36.3158 87.7957 35.9831 88.5587 35.3909 89.1213C34.7986 89.6839 33.9954 90 33.1579 90C32.3204 90 31.5171 89.6839 30.9249 89.1213C30.3327 88.5587 30 87.7957 30 87V78C30 77.2043 30.3327 76.4413 30.9249 75.8787C31.5171 75.3161 32.3204 75 33.1579 75C33.9954 75 34.7986 75.3161 35.3909 75.8787C35.9831 76.4413 36.3158 77.2043 36.3158 78ZM52.1053 66C52.1053 65.2043 51.7726 64.4413 51.1803 63.8787C50.5881 63.3161 49.7849 63 48.9474 63C48.1098 63 47.3066 63.3161 46.7144 63.8787C46.1222 64.4413 45.7895 65.2043 45.7895 66V87C45.7895 87.7957 46.1222 88.5587 46.7144 89.1213C47.3066 89.6839 48.1098 90 48.9474 90C49.7849 90 50.5881 89.6839 51.1803 89.1213C51.7726 88.5587 52.1053 87.7957 52.1053 87V66ZM64.7368 69C65.5744 69 66.3776 69.3161 66.9698 69.8787C67.562 70.4413 67.8947 71.2043 67.8947 72V87C67.8947 87.7957 67.562 88.5587 66.9698 89.1213C66.3776 89.6839 65.5744 90 64.7368 90C63.8993 90 63.0961 89.6839 62.5039 89.1213C61.9117 88.5587 61.5789 87.7957 61.5789 87V72C61.5789 71.2043 61.9117 70.4413 62.5039 69.8787C63.0961 69.3161 63.8993 69 64.7368 69ZM83.6842 57C83.6842 56.2044 83.3515 55.4413 82.7593 54.8787C82.1671 54.3161 81.3638 54 80.5263 54C79.6888 54 78.8856 54.3161 78.2933 54.8787C77.7011 55.4413 77.3684 56.2044 77.3684 57V87C77.3684 87.7957 77.7011 88.5587 78.2933 89.1213C78.8856 89.6839 79.6888 90 80.5263 90C81.3638 90 82.1671 89.6839 82.7593 89.1213C83.3515 88.5587 83.6842 87.7957 83.6842 87V57Z'
										fill='#FFEE24'
									></path>
								</svg>
							</div>
							<p className='card-title'>Efficiency and Performance</p>
							<p className='card-description'>
								We understand the competitive nature of the industry. That's why
								efficiency is at the core of our operations. We strive to
								perform at the highest levels, ensuring timely delivery and
								cost-effective solutions without compromising on quality.
							</p>
						</div>
					</div>

					<div className='card'>
						<div className='container-card bg-blue-box'>
							<div className='card-svg flex-container'>
								<svg
									height='50px'
									width='50px'
									version='1.1'
									id='_x32_'
									xmlns='http://www.w3.org/2000/svg'
									xmlnsXlink='http://www.w3.org/1999/xlink'
									viewBox='0 0 512 512'
									xmlSpace='preserve'
								>
									<g>
										<path
											className='st0'
											d='M255.366,141.046c-7.4,3.583-14.732,8.548-21.533,15.357c-34.091,34.098-65.081,65.088-65.081,65.088
		l0.013,0.02c-0.185,0.186-0.371,0.338-0.557,0.53c-8.824,8.831-9.174,22.909-1.025,32.146c0.323,0.371,0.668,0.736,1.025,1.086
		c9.161,9.174,24.036,9.196,33.232,0l35.797-35.797c6.176,2.263,12.248,3.583,18.074,4.243c7.937,0.88,15.392,0.55,22.022-0.385
		c16.162-2.29,14.47-1.623,23.844-4.704c9.353-3.068,19.862-9.354,19.862-9.354l6.362,6.355
		c0.701,0.681,16.919,16.925,25.192,25.185c1.465,1.471,2.709,2.682,3.542,3.549c0.956,0.997,2.022,1.719,2.682,2.682l41.278,41.279
		c11.898-13.35,25.488-33.232,23.81-56.058L320.763,129.14C320.763,129.14,285.062,126.589,255.366,141.046z'
											fill='#87A1FF'
										></path>
										<path
											className='st0'
											d='M261.115,394.362c-9.134-9.147-23.961-9.147-33.101,0l-6.794,6.794c9.119-9.132,9.112-23.926-0.021-33.066
		c-9.14-9.126-23.947-9.126-33.087,0.007c9.14-9.133,9.14-23.94,0-33.087c-9.133-9.148-23.947-9.133-33.087,0
		c9.14-9.133,9.14-23.947,0-33.095c-9.134-9.132-23.947-9.132-33.088,0.014l-20.46,20.453c-9.14,9.147-9.14,23.947,0,33.094
		c9.133,9.134,23.941,9.134,33.08,0c-9.14,9.134-9.14,23.947,0,33.087c9.147,9.133,23.954,9.133,33.094,0
		c-9.14,9.133-9.14,23.941,0,33.088c9.14,9.133,23.947,9.133,33.088,0l6.802-6.809c-9.119,9.147-9.113,23.94,0.02,33.081
		c9.14,9.132,23.947,9.132,33.088,0l20.467-20.468C270.248,418.302,270.248,403.495,261.115,394.362z'
											fill='#87A1FF'
										></path>
										<path
											className='st0'
											d='M507.987,178.28L387.543,57.822c-5.351-5.337-14.002-5.337-19.339,0l-38.631,38.63
		c-5.337,5.337-5.337,13.989,0,19.333l120.458,120.451c5.33,5.35,13.996,5.35,19.326,0l38.63-38.638
		C513.338,192.276,513.338,183.624,507.987,178.28z M473.655,204.992c-5.75,5.736-15.048,5.736-20.777,0
		c-5.735-5.743-5.735-15.041,0-20.777c5.729-5.736,15.027-5.736,20.777,0C479.391,189.951,479.384,199.249,473.655,204.992z'
											fill='#87A1FF'
										></path>
										<path
											className='st0'
											d='M182.417,99.864l-38.624-38.63c-5.336-5.337-13.995-5.337-19.332,0L4.003,181.691
		c-5.337,5.323-5.337,13.989,0,19.319l38.631,38.644c5.33,5.331,14.002,5.331,19.325,0l120.458-120.458
		C187.761,113.859,187.761,105.207,182.417,99.864z M59.118,208.403c-5.736,5.729-15.04,5.729-20.777,0
		c-5.735-5.742-5.735-15.041,0-20.777c5.736-5.735,15.041-5.735,20.777,0C64.854,193.362,64.854,202.66,59.118,208.403z'
											fill='#87A1FF'
										></path>
										<path
											className='st0'
											d='M397.528,312.809l-7.468-7.482l-72.509-72.509l-4.883,2.166l-5.316,1.919l-0.384,0.117
		c-0.936,0.296-9.684,2.971-26.932,5.412c-9.12,1.273-18.156,1.431-26.904,0.434c-3.459-0.385-6.898-0.95-10.296-1.692
		l-27.757,27.744c-16.678,16.678-43.836,16.678-60.514,0c-0.585-0.591-1.149-1.19-1.671-1.781l-0.179-0.2
		c-10.529-11.939-13.204-28.28-8.252-42.461l10.673-16.609l-0.02-0.02l65.081-65.074c2.647-2.641,5.426-5.103,8.314-7.428
		c-20.281-3.982-37.296-2.806-37.296-2.806L88.093,235.679c-1.389,18.988,11.651,39.799,20.928,51.952
		c16.692-15.963,43.239-15.756,59.641,0.654c6.107,6.1,9.952,13.617,11.574,21.498c7.895,1.637,15.406,5.475,21.513,11.582
		c6.107,6.114,9.952,13.631,11.575,21.519c7.888,1.623,15.412,5.46,21.513,11.568c4.078,4.078,7.152,8.783,9.222,13.817
		c11.1-0.137,22.242,4.016,30.688,12.455c16.65,16.636,16.643,43.733,0,60.363l-6.809,6.822l3.411,3.412
		c9.148,9.147,23.954,9.147,33.095,0c9.14-9.134,9.14-23.947,0-33.088l6.808,6.83c9.147,9.133,23.947,9.133,33.087,0
		c9.14-9.147,9.147-23.954,0-33.101c9.147,9.147,23.947,9.147,33.087,0c9.134-9.126,9.154-23.94,0-33.088
		c9.154,9.148,23.954,9.148,33.088,0c9.147-9.132,9.147-23.947,0-33.08L397.528,312.809z'
											fill='#87A1FF'
										></path>
									</g>
								</svg>
							</div>
							<p className='card-title'>Global Partnership</p>
							<p className='card-description'>
								We envision ourselves not just as a supplier, but as a strategic
								partner in constructing the future. Our goal is to be your main
								and trusted source for industrial and construction products
								worldwide, collaborating closely to achieve mutual success.
							</p>
						</div>
					</div>
				</div>
			</div>
			<p className='quality-bottom-para'>
				At Krad Global, great service and product quality are not just promises
				but commitments we uphold with every client and project. We invite you
				to experience the Krad Global difference.
			</p>
		</div>
	);
};

export default QualitySection;
